import Header from 'components/Header';
import './index.scss';
function ErrorPage(props) {
  const { errorDetails = {}, isAuthorized = false } = props;
  // function extractContent(html) {
  //   return new DOMParser().parseFromString(html, 'text/html').documentElement.textContent;
  // }
  return (
    <div className="error-page">
      <Header isAuthorized={isAuthorized} isHideuserInfo={true} />
      <div className="error-resize">
        <h1>{errorDetails.response?.status}</h1>
        {errorDetails.response?.status == 500 ? (
          <div dangerouslySetInnerHTML={{ __html: errorDetails.response?.data }} />
        ) : (
          <p>{errorDetails.response?.data.message}</p>
        )}
      </div>
    </div>
  );
}
export default ErrorPage;
